/** "Quiénes somos" (DESIGN.md): headline left, text right. */
const AboutUs = () => (
  <section id="about" aria-labelledby="about-heading" className="pq-section">
    <div className="pq-wrap pq-faq-wrap">
      <h2 id="about-heading" className="pq-headline">¿Quiénes somos?</h2>
      <div className="pq-prose">
        <p>
          Somos samarios apasionados por el Parque Nacional Natural Tayrona y
          creamos esta guía para conectarte con las mejores opciones para acampar
          en Santa Marta y en uno de los destinos más espectaculares de Colombia.
        </p>
        <p>
          Reunimos los campamentos dentro del parque para todos los presupuestos:
          desde opciones económicas en Arrecifes para mochileros hasta ecohabs y
          glamping con servicios completos junto a Cabo San Juan. Nuestro objetivo
          es que llegues preparado, sin sorpresas.
        </p>
        <p>
          No somos guías oficiales del parque ni tenemos vínculo con Parques
          Nacionales Naturales de Colombia ni con ningún operador. Esta es una guía
          independiente, hecha por gente de la costa. El parque cambia con el
          tiempo, así que antes de viajar confirma siempre tarifas y cierres
          directamente con el campamento y con Parques Nacionales.
        </p>
      </div>
    </div>
  </section>
);

export default AboutUs;
